import { render, staticRenderFns } from "./wode.vue?vue&type=template&id=4168f4aa&scoped=true"
import script from "./wode.vue?vue&type=script&lang=js"
export * from "./wode.vue?vue&type=script&lang=js"
import style0 from "./wode.vue?vue&type=style&index=0&id=4168f4aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4168f4aa",
  null
  
)

export default component.exports